<template>
  <v-container>
    <v-row class="text-center">
      <v-col offset="3" cols="6">
        <v-card class="pa-5">
          <v-card-title>
            Error
          </v-card-title>
          <v-card-text>
            <img src="https://www.gstatic.com/youtube/src/web/htdocs/img/monkey.png"/>
            <h2>Ein Fehler is aufgetreten</h2>
            <p>
              Fehlercode: <code>{{ $route.query.errorCode }}</code>
            </p>
            <p>
              <v-btn
                color="success"
                class="mt-4"
                @click="$router.push({path: '/'}).catch(() => {})"
              >
                Auf die Hauptseite zurück
              </v-btn>
            </p>
            <p>
              <v-btn
                color="success"
                class="mt-4"
                @click="$router.push({path: $route.query.targetRoute}).catch(() => {})"
              >
                Erneut versuchen?
              </v-btn>
            </p>            
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Error',
  mounted() {

  },
  methods: {

  },
  created() {

  }
};
</script>
